//import { Counter } from "./components/Counter";
//import { CheckoutTest } from "./components/CheckoutTest";
//import { CheckoutV2 } from "./components/checkoutV2";
import { PunchoutTest } from "./components/PunchoutTest";
import CheckoutHook from "./components/CheckoutHook";
import ConfirmPage  from "./components/ConfirmPage";
import SessionExpired from "./components/SessionExpired";
import HelpCenter from './components/HelpCenter';
import OrderItem from "./components/OrderItem";
import ReturnDetails from "./components/ReturnDetails";
import ConfirmReturn from "./components/ConfirmReturn";
import ContactUs from "./components/ContactUs";
import Faqs from "./components/Faqs";
import ContactConfirm from "./components/ContactConfirm";
import ShippingLabel from "./components/ShippingLabel";
import DealerHome from "./components/dealer/DealerHome";
import OrderStep2 from "./components/dealer/order/OrderStep2";
import NewOrder from "./components/dealer/order/NewOrder";
import SSOTest from "./components/dealer/SSOTest";
import Login from "./components/dealer/Login";
import KMCAPITest from "./components/dealer/KMCAPITest";
import CreditRequest from "./components/dealer/credit/CreditRequest";
import OrderHistory from "./components/dealer/order/OrderHistory";
import CreditHistory from "./components/dealer/credit/CreditHistory";
import HelpCenterDealer from "./components/dealer/HelpCenterDealer";
import FaqsDealer from "./components/dealer/FaqsDealer";
import KCountriesHome from "./components/dealer/KCountriesHome";
import KLoyalty from "./components/dealer/KLoyalty";
import ComingSoon from "./components/dealer/ComingSoon";
import InventoryList from "./components/catalog/InventoryList";
import ItemEdit from "./components/catalog/ItemEdit";
import Catalog from "./components/catalog/Catalog";
import Item from "./components/catalog/Item";
import AboutTheProgram from "./components/dealer/AboutTheProgram";
import BackOrders from "./components/dealer/BackOrders";
import SavedOrders from "./components/dealer/SavedOrders";
import AllocatedOrders from "./components/dealer/kcountry/AllocatedOrders";
import Error from "./components/Error.js";

const AppRoutes = [
    {
        index: true,
/*        element: <CheckoutTest />*/
        element: <CheckoutHook />
/*        element: <Home />*/
    },
    {
        path: '/punchout-test',
        element: <PunchoutTest />
    },

    {
        path: '/checkouthook',
        element: <CheckoutHook />
    },
    {
        path: '/confirmpage',
        element: <ConfirmPage />
    },
    {
        path: '/sessionexpired',
        element: <SessionExpired />
    },
    {
        path: '/helpcenter',
        element: <HelpCenter />
    },
    {
        path: '/orderitem',
        element: <OrderItem />
    },
    {
        path: '/returndetails',
        element: <ReturnDetails />
    },
    {
        path: '/confirmreturn',
        element: <ConfirmReturn />
    },
    {
        path: '/contactus',
        element: <ContactUs />
    },
    {
        path: '/faqs',
        element: <Faqs />
    },
    {
        path: '/contactconfirm',
        element: <ContactConfirm />
    },
    {
        path: '/label',
        element: <ShippingLabel />
    },
    {
        path: '/dealerhome',
        element: <DealerHome />
    },
    {
        path: '/orderstep2',
        element: <OrderStep2 />
    },
    {
        path: '/neworder',
        element: <NewOrder />
    },
    {
        path: '/ssotest',
         element: <SSOTest />
    },
    {
        path: '/login',
        element: <Login />
    },
    {
        path: '/kmcapitest',
        element: <KMCAPITest />
    },
    {
        path: '/creditrequest',
        element: <CreditRequest />
    },
    {
        path: '/orderhistory',
        element: <OrderHistory />
    },
    {
        path: '/credithistory',
        element: <CreditHistory />
    },
    {
        path: '/dealer/helpcenter',
        element: <HelpCenterDealer />
    },
    {
        path: '/dealer/faqs',
        element: <FaqsDealer />
    },
    {
        path: '/kcountrieshome',
        element: <KCountriesHome />
    },
    {
        path: '/kloyalty',
        element: <KLoyalty />
    },
    {
        path: '/comingsoon',
        element: <ComingSoon />
    },
    {
        path: '/inventorylist',
        element: <InventoryList />
    },
    {
        path: '/catalog/itemedit',
        element: <ItemEdit />
    },
    {
        path: '/catalog',
        element: <Catalog />
    },
    {
        path: '/catalog/item',
        element: <Item />
    },
    {
        path: '/dealer/about',
        element: <AboutTheProgram />
    },
    {
        path: '/backorders',
        element: <BackOrders />
    },
    {
        path: '/savedorders',
        element: <SavedOrders />
    },
    {
        path: '/allocatedorders',
        element: <AllocatedOrders />
    },
    {
        path: '/error',
        element: <Error />
    }
];

export default AppRoutes;
